import React, { useState } from 'react';

const GrayButton = ({ 
  children, 
  onClick, 
  disabled = false, 
  type = 'button',
  style = {},
  className = ''
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const buttonStyle = {
    backgroundColor: disabled ? '#d1d5db' : (isHovered ? '#9ca3af' : '#e5e7eb'),
    color: disabled ? '#9ca3af' : '#374151',
    border: 'none',
    borderRadius: '8px',
    padding: '10px 20px',
    cursor: disabled ? 'not-allowed' : 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    transition: 'all 0.3s ease',
    opacity: disabled ? 0.6 : 1,
    transform: isHovered && !disabled ? 'translateY(-1px)' : 'translateY(0)',
    boxShadow: isHovered && !disabled ? '0 4px 8px rgba(0, 0, 0, 0.1)' : '0 2px 4px rgba(0, 0, 0, 0.05)',
    outline: 'none',
    ...style
  };

  return (
    <button
      style={buttonStyle}
      onClick={onClick}
      disabled={disabled}
      type={type}
      className={className}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}
    </button>
  );
};

export default GrayButton;
